import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { AdminsLoadingDialog } from "./admins-loading-dialog/AdminsLoadingDialog";
import { AdminDeleteDialog } from "./admin-delete-dialog/AdminDeleteDialog";
import { AdminsDeleteDialog } from "./admins-delete-dialog/AdminsDeleteDialog";
import { AdminsFetchDialog } from "./admins-fetch-dialog/AdminsFetchDialog";
import { AdminsUpdateStatusDialog } from "./admins-update-status-dialog/AdminsUpdateStatusDialog";
import { AdminsCard } from "./AdminsCard";
import { AdminsUIProvider } from "./AdminsUIContext";

function AdminsDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <AdminsDeleteDialog show={location.pathname === "/admin/deleteAdmins" || location.pathname === "/admin/deleteAdmins/"} onHide={() => navigate("/admin")} />;
}
function AdminDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  return <AdminDeleteDialog show id={id} onHide={() => navigate("/admin")} />;
}
function AdminsFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <AdminsFetchDialog show={location.pathname === "/admin/fetch"} onHide={() => navigate("/admin")} />;
}
function AdminsUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <AdminsUpdateStatusDialog show={location.pathname === "/admin/updateStatus"} onHide={() => navigate("/admin")} />;
}

export function AdminsPage() {
  const navigate = useNavigate();
  const adminsUIEvents = {
    newAdminButtonClick: () => navigate("/admin/new"),
    openEditAdminPage: (id) => navigate(`/admin/${id}/edit`),
    openDeleteAdminDialog: (id) => navigate(`/admin/${id}/delete`),
    openDeleteAdminsDialog: () => navigate("/admin/deleteAdmins"),
    openFetchAdminsDialog: () => navigate("/admin/fetch"),
    openUpdateAdminsStatusDialog: () => navigate("/admin/updateStatus"),
  };

  return (
    <AdminsUIProvider adminsUIEvents={adminsUIEvents}>
      <AdminsLoadingDialog />
      <Routes>
        <Route path="deleteAdmins" element={<AdminsDeleteDialogRoute />} />
        <Route path=":id/delete" element={<AdminDeleteDialogRoute />} />
        <Route path="fetch" element={<AdminsFetchDialogRoute />} />
        <Route path="updateStatus" element={<AdminsUpdateStatusDialogRoute />} />
      </Routes>
      <AdminsCard />
    </AdminsUIProvider>
  );
}
